export const styles = {
    tabButton: (isActive) => ({
        backgroundColor: isActive ? '#e3f2fd' : 'transparent',
        color: isActive ? '#1976d2' : '#6B7280',
        '&:hover': {
            backgroundColor: isActive ? '#bbdefb' : '#f3f4f6'
        },
        margin: { xs: '0 4px', md: '0 8px' },
        borderBottom: isActive ? '3px solid #1976d2' : 'none',
        borderRadius: '8px 8px 0 0',
        fontSize: { xs: '0.875rem', md: '0.9375rem' },  
        fontWeight: 600,
        px: { xs: 2, md: 3 },  
        py: { xs: 1, md: 1.25 }, 
        transition: 'all 0.2s ease',
        textTransform: 'none',
        minHeight: 'auto'  
    }),
    tabContainer: {
        borderBottom: '2px solid #e5e7eb',
        marginBottom: { xs: 2, md: 3 },
        paddingBottom: 0,
        display: 'flex',
        gap: { xs: 0.5, md: 1 },
        backgroundColor: '#fff',
        px: 2
    }
};

export const softColors = {
    primary: "#6B7280",
    background: "#F9FAFB",
    border: "#E5E7EB",
    hover: "#F3F4F6",
    success: "#84cc16",
    error: "#ef4444",
    text: "#374151",
    secondaryText: "#6B7280",
};